module.exports = __webpack_public_path__ + "img/blog-page-4.f9b5f932.jpg";